import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Alert, Button, ButtonGroup, CloseButton, Container, FloatingLabel, Form, Image, InputGroup, ProgressBar, Spinner, Tab, Tabs, ToggleButton } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { LoginInfo } from '../App';
import ImageFile from '../domain/ImageFile';
import * as ImageUtil from '../service/ImageUtil';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import MosaicEditPopup from './MosaicEditPopup';
import MuiButton from '@mui/material/Button';
import { DataGrid } from '@mui/x-data-grid';
import { Box, FormControl, IconButton, InputLabel, MenuItem, Select, Switch, TablePagination, TextField, Tooltip, Typography } from '@mui/material';
import Cropper from 'react-easy-crop';

const CharacterEditPopup = (props) => {
    async function getImageInfo(groupId) {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/character/infoLatest/" + groupId).then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function deleteImage(groupId) {
        return await new ApiFetch().delete(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/character/post/" + groupId).then((r) => r.json().then((d) => {
            return d
        }))
    }
    async function getPlanList() {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/plan/peoples/")
            .then((r) => r.json().then((json) => {
                return json
            }))
    }
    async function getLimitedDataList(groupId, index) {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/character/limitedData/" + groupId + "/" + index).then((r) => r.json().then((json) => {
            return json
        }))
    }
    const { t, i18n } = useTranslation()
    // ログイン情報
    const { loginInfo, setLoginInfo } = useContext(LoginInfo)
    // ナビゲーション
    const navigate = useNavigate();

    // 年齢制限
    const [ageLimit, setAgeLimit] = useState("")
    const [sexualExpression, setSexualExpression] = useState('')

    // 画像情報
    const [imageInfo, setImageInfo] = useState({ info: { id: "", character_name: "", description: "" }, detail: [] });
    const [imageInfoStatus, setImageInfoStatus] = useState(false);
    const [detailId, setDetailId] = useState(0)
    const [detailNo, setDetailNo] = useState(0)
    const [planList, setPlanList] = useState([])

    // 支援プラン選択
    const [limitDiv, setLimitDiv] = useState("")
    const [selectionPlans, setSelectionPlans] = useState([])
    const columns = [
        { field: 'name', headerName: 'プラン名', width: 130, sortable: false, disableColumnMenu: true },
        { field: 'amount', headerName: '月額', width: 130, sortable: false, disableColumnMenu: true },
        {
            field: 'count',
            headerName: '支援者数',
            type: 'number',
            width: 90,
            sortable: false,
            disableColumnMenu: true
        },
        { field: 'age_limit', headerName: '年齢制限', width: 130, sortable: false, disableColumnMenu: true },
    ]
    const [rows, setRows] = useState([])
    const [unitSell, setUnitSell] = useState("2")
    const [unitAmount, setUnitAmount] = useState(500)

    useEffect(() => {
        if (unitSell === "1" && unitAmount === -1) {
            setUnitAmount(500)
        } else if (unitSell === "2") {
            setUnitAmount(-1)
        }
    }, [unitSell])

    // パラメータ
    const param = useParams()
    let groupId = props.groupId

    // 画像遅延ロード
    const options = {
        root: null,
        rootMargin: "0px",
        threshold: 0.05
    }

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.intersectionRatio > 0) {
                const imgEl = entry.target;
                imgEl.src = imgEl.dataset.src;
                observer.unobserve(entry.target);
            }
        })
    }, options)

    function edit(groupId, backgroundImage, profileImage, characterName, characterNameKana, characterSex, characterBirthday, characterAge, hobby, notes, fanart, fanartHashTag,
        xId, youtubeId, instagramId, tiktokId, misskeyId, discordUserName, githubId, huggingfaceId, homepage,
        description, original, limitedPublication, displayNewList, displayRanking, prompt, negativePrompt) {
        setSaving(true)
        new ApiFetch().put(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/upload/character",
            {
                groupId: groupId, backgroundImage: backgroundImage.startsWith("data:") ? backgroundImage : "", profileImage: profileImage.startsWith("data:") ? profileImage : "", characterName: characterName, characterNameKana: characterNameKana, characterSex: characterSex,
                characterBirthday: characterBirthday, characterAge: characterAge, hobby: hobby, notes: notes, fanart: fanart, fanartHashTag: fanartHashTag,
                xId: xId, youtubeId: youtubeId, instagramId: instagramId, tiktokId: tiktokId,
                misskeyId: misskeyId, discordUserName: discordUserName, githubId: githubId, huggingfaceId: huggingfaceId,
                homepage: homepage,
                description: description, system: system,
                original: original,
                limitedPublication: limitedPublication, limitDiv: limitDiv, selectionPlans: selectionPlans, unitAmount: unitAmount,
                displayNewList: displayNewList, displayRanking: displayRanking, ageLimit: ageLimit, sexualExpression: sexualExpression, styleOfPainting: styleOfPainting, prompt: prompt, negativePrompt: negativePrompt,
                gachaEnabled: gachaEnabled,gachaPrompts: gachaPrompts,gachaPublicPromptEnabled:gachaPublicPromptEnabled ? 1 : 0
            }).then((r) => {
                return r.json().then((json) => {
                    if (json.result) {
                        setGachaPrompts(json.gachaPromptsList)
                        dialog(t("common.confirm"), "更新が完了しました。")
                    } else {
                        dialog(t("common.error"), json.errors.join("\r\n"))
                    }
                    setSaving(false)
                    return json.result
                })
            })
    }

    const [limitedDataList, setLimitedDataList] = useState([])
    const [oldGroupId, setOldGroupId] = useState("")
    const [promptList, setPromptList] = useState([])
    const [negativePromptList, setNegativePromptList] = useState([])

    const [backgroundImage, setBackgroundImage] = useState("")
    const [profileImage, setProfileImage] = useState("")
    const [srcImage, setSrcImage] = useState("")
    useEffect(() => {
        // タイトル設定
        //document.querySelector("title").textContent = t("common.edit") + " - " + t("common.siteName")
        getImageInfo(groupId).then(r => {
            if (r.result) {
                setImageInfo(r)
                setImageInfoStatus(true)
                setCharacterName(r.info.character_name)
                setCharacterNameKana(r.info.character_name_kana)
                setCharacterSex(String(r.info.character_sex))
                setBirthdaySet(r.info.character_birthday === "00-00" ? "2" : "1")
                let birthday = r.info.character_birthday.split("-")
                setMonth(parseInt(birthday[0]))
                setDay(parseInt(birthday[1]))
                setCharacterAge(String(r.info.character_age))
                setAgeLimit(String(r.info.age_limit))
                if (String(r.info.age_limit) === "1") {
                    setSexualExpression("2")
                } else {
                    setSexualExpression(String(r.info.sexual_expression))
                }
                setStyleOfPainting(String(r.info.style_of_painting))
                setDescription(r.info.description)
                setHobby(r.info.hobby)
                setNotes(r.info.notes)
                setSystem(r.info.system)
                setFanart(String(r.info.fanart))
                setFanartHashTag(r.info.fanart_hash_tag)
                setXId(r.info.x_id)
                setYouTubeId(r.info.youtube_id)
                setInstagramId(r.info.instagram_id)
                setTiktokId(r.info.tiktok_id)
                setMisskeyId(r.info.misskey_id)
                setDiscordUserName(r.info.discord_user_name)
                setGitHubId(r.info.github_id)
                setHuggingFaceId(r.info.huggingface_id)
                setHomepage(r.info.homepage)
                setPromptList(r.detail.map(d => d.prompt))
                setNegativePromptList(r.detail.map(d => d.negative_prompt))
                let planList = r.info.plan_list || []
                setPlanList(planList)
                setSelectionPlans(planList.map(d => d.plan_id))
                setLimitDiv(r.info.limit_div)
                // 支援者限定コンテンツを取得
                let limitedList = []
                r.detail.map((d, i) => {
                    console.log("a", d.sort_order)
                    return getLimitedDataList(groupId, i).then(r => {
                        if (r.result) {
                            d.base64 = r.list
                        } else {
                            d.base64 = []
                        }
                        limitedList[d.sort_order] = r.list
                        setLimitedDataList(limitedList)
                        console.log("b", d.sort_order)
                    })
                })
                setUnitSell(r.info.unit_amount > -1 ? "1" : "2")
                setUnitAmount(r.info.unit_amount)
                setBackgroundImage("//" + ApiFetch.IMG_HOST + "/character/post/t/" + groupId + "_out.webp?" + r.info.hash)
                setProfileImage("//" + ApiFetch.IMG_HOST + "/character/post/t/" + groupId + "_in.webp?" + r.info.hash)

                // ガチャ設定
                setGachaPublicPromptEnabled(r.info.gacha_public_prompt_enabled === 1)
                setGachaPrompts(r.info.gacha_prompts)
            }
        })
        getPlanList().then(r => {
            if (r.result) {
                setRows(r.data.map(d => {
                    d.id = d.plan_id
                    d.amount = "￥" + d.amount.toLocaleString()
                    return d
                }))
            } else {
                setRows([].concat())
            }
        })
        if (oldGroupId !== "" && oldGroupId !== groupId) {
            props.switch(false)
        }
        setOldGroupId(groupId)
    }, [groupId])

    // ダイアログ
    const [show, setShow] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    function dialog(title, message) {
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    // 画像遅延ロード
    useEffect(() => {
        //document.querySelectorAll(".lazy").forEach(e => observer.observe(e))
    }, [imageInfo, groupId])

    // エラーメッセージ
    const [message, setMessage] = useState('');
    const [messageShow, setMessageShow] = useState('none');

    const nenrei = [
        { name: t("upload.image.ageLimitG"), value: '1' },
        { name: t("upload.image.ageLimitPG12"), value: '2' },
        { name: t("upload.image.ageLimitR15"), value: '3' },
        { name: t("upload.image.ageLimitR18"), value: '4' },
        { name: t("upload.image.ageLimitR18G"), value: '5' },
    ];

    const yesOrNoRadio = [
        { name: t("common.no"), value: "2" },
        { name: t("common.yes"), value: "1" },
    ];

    const [showMosaicEditPopup, setShowMosaicEditPopup] = useState(false)
    const [saving, setSaving] = useState(false)
    document.onkeydown = (e) => {
        if (e.key === "Escape") {
            props.switch(false)
        }
    }

    const [characterName, setCharacterName] = useState('')
    const [characterNameKana, setCharacterNameKana] = useState('')
    const [characterAge, setCharacterAge] = useState('')
    const [styleOfPainting, setStyleOfPainting] = useState('')
    const [description, setDescription] = useState('')
    const [hobby, setHobby] = useState('')
    const [notes, setNotes] = useState('')
    const [system, setSystem] = useState('')
    const [fanart, setFanart] = useState('')
    const [characterSex, setCharacterSex] = useState('')
    const [fanartHashTag, setFanartHashTag] = useState('')
    const [xId, setXId] = useState('')
    const [youtubeId, setYouTubeId] = useState('')
    const [instagramId, setInstagramId] = useState('')
    const [tiktokId, setTiktokId] = useState('')
    const [misskeyId, setMisskeyId] = useState('')
    const [discordUserName, setDiscordUserName] = useState('')
    const [githubId, setGitHubId] = useState('')
    const [huggingfaceId, setHuggingFaceId] = useState('')
    const [homepage, setHomepage] = useState('')

    const styles = [
        { name: t("upload.image.illustration"), value: '1' },
        { name: t("upload.image.semirealism"), value: '3' },
        { name: t("upload.image.photorealistic"), value: '2' },
    ]

    const sexRadio = [
        { name: "男", value: '1' },
        { name: "女", value: '2' },
        { name: "その他", value: '3' },
    ]

    const [birthdaySet, setBirthdaySet] = useState("2")
    const [month, setMonth] = useState(0)
    const [day, setDay] = useState(0)

    useEffect(() => {
        if (birthdaySet === "2") {
            setMonth(0)
            setDay(0)
        }
    }, [birthdaySet])

    const months = [];
    for (let month = 1; month <= 12; month++) {
        months.push(month);
    }
    const days = [];
    for (let day = 1; day <= 31; day++) {
        days.push(day);
    }

    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [zoom, setZoom] = useState(1)
    const [showCropper, setShowCropper] = useState()
    const [cropTarget, setCropTarget] = useState()
    const [tempThumbnail, setTempThumbnail] = useState()
    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        let image = document.getElementById("load-image")

        let canvas = document.createElement("canvas")
        let ctx = canvas.getContext("2d")
        canvas.width = image.width
        canvas.height = image.height

        ctx.drawImage(image, 0, 0)

        const data = ctx.getImageData(croppedAreaPixels.x, croppedAreaPixels.y, croppedAreaPixels.width, croppedAreaPixels.height)

        canvas.width = croppedAreaPixels.width
        canvas.height = croppedAreaPixels.height

        ctx.putImageData(data, 0, 0)

        let thumb = canvas.toDataURL("image/png")

        setTempThumbnail(thumb)
    }, [])

    const [gachaPrompts, setGachaPrompts] = useState([{id:"", prompt: "", negativePrompt: "" }]);
    const [gachaEnabled, setGachaEnabled] = useState(false);
    const [gachaPublicPromptEnabled, setGachaPublicPromptEnabled] = useState(false);
    const [gachaPrice, setGachaPrice] = useState(0);

    function addGachaPrompt() {
        setGachaPrompts([...gachaPrompts, {id:"", prompt: "", negativePrompt: "" }]);
    }

    function removeGachaPrompt(index) {
        setGachaPrompts(gachaPrompts.filter((_, i) => i !== index));
    }

    function updateGachaPrompt(index, field, value) {
        const updatedPrompts = [...gachaPrompts];
        updatedPrompts[index][field] = value;
        setGachaPrompts(updatedPrompts);
    }

    return (
        <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "#000000", zIndex: 4 }}>
            <Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} />
            {showMosaicEditPopup ? <MosaicEditPopup type="character" switch={setShowMosaicEditPopup} groupId={groupId} detailId={detailId} detailNo={detailNo} /> : ""}
            <div id="edit-popup" style={{ position: "fixed", top: "1%", left: "1%", width: "98%", height: "98%", zIndex: 5, overflow: "auto", backgroundColor: "#FFFFFF", borderRadius: "20px" }}>
                <Button variant='secondary' className='m-3' style={{ position: "fixed", left: "14px", zIndex: 1 }} onClick={() => props.switch(false)}>{t("common.close")}</Button>
                {showCropper ? (
                    <Container>
                        <Cropper
                            classes={{ containerClassName: "cropper-container" }}
                            image={srcImage}
                            crop={crop}
                            zoom={zoom}
                            aspect={cropTarget === "outside" ? 2 / 1 : 1 / 1}
                            onCropChange={setCrop}
                            onCropComplete={onCropComplete}
                            onZoomChange={setZoom}

                        />
                        <Container style={{ position: "absolute", width: "300px", height: "110px", zIndex: 3, left: window.innerWidth / 2 - 150, bottom: "60px", borderRadius: "10px", backgroundColor: "#EEEEEE" }} className="p-3">
                            <FloatingLabel controlId="crop-zoom" label="" className="mb-3"
                                style={{ position: "absolute", zIndex: 3, top: 0, width: "90%", fontSize: "24px" }}
                            >
                                <Form.Range type="range" defaultValue={zoom} min={1} max={5} step={0.1} onChange={(e) => {
                                    setZoom(e.currentTarget.value)
                                }} />
                            </FloatingLabel>
                            <Button style={{ position: "absolute", zIndex: 3, left: "30px", bottom: "10px", fontSize: "24px" }} onClick={() => {
                                if (cropTarget === "outside") {
                                    setBackgroundImage(tempThumbnail)
                                } else {
                                    setProfileImage(tempThumbnail)
                                }
                                setShowCropper(false)
                            }}>OK</Button>
                            <Button variant='secondary' style={{ position: "absolute", zIndex: 3, right: "30px", bottom: "10px", fontSize: "24px" }} onClick={() => {
                                setShowCropper(false)
                            }}>Cancel</Button>
                        </Container>
                    </Container>
                ) : ""}
                <Container className='d-flex flex-row justify-content-center flex-wrap' style={{ marginTop: "60px", marginBottom: "200px" }}>
                    <Tabs defaultActiveKey="account" id="uncontrolled-tab-example" className="mt-3 mb-3 w-100">
                        <Tab eventKey="account" title={"キャラクター"} style={{ position: "relative", flex: "1" }}>
                            {imageInfoStatus && imageInfo.info.problem_status === 1 ? (
                                <Container style={{ color: "red", fontWeight: "bold", fontSize: "24px", border: "3px solid red" }} className="mb-3">
                                    {imageInfo.info.problem_reason === 1 ? <>隠蔽処理(モザイク等)の対応が必要です。<br /><Icon.Pencil />マークでモザイク編集することもできます。</> : <>児童ポルノまたは類似表現の修正が必要です。</>}
                                </Container>
                            ) : ""}
                            {imageInfoStatus && imageInfo.detail.length > 0 ? (
                                <Container className="d-flex justify-content-start align-items-center" style={{ flexWrap: "wrap", width: "100%", padding: "5px", backgroundColor: "#FFFFFF", border: "1px solid #CCCCCC", borderRadius: "5px" }}>
                                    {imageInfo.detail.map((d, i) => {
                                        return (
                                            <div style={{ position: "relative", flexShrink: 0, width: "100px", height: "100px", overflow: "hidden" }} className="m-1" key={d.id}>
                                                <Icon.PencilFill style={{ color: "#0000FF", fontSize: "24px", position: "absolute", right: "5px", top: "5px", borderRadius: "20px", backgroundColor: "#FFFFFF", cursor: "pointer" }}
                                                    onClick={(e) => {
                                                        setShowMosaicEditPopup(true)
                                                        setDetailId(d.id)
                                                        setDetailNo(d.sort_order)
                                                    }} title={t("common.editMosaic")} />
                                                <Image src={limitDiv === "public" ? "http://" + ApiFetch.IMG_HOST + "/character/post/t/" + d.id + ".jpg" : limitedDataList[i] !== undefined ? limitedDataList[i].t_m_webp : ""} style={{ objectFit: "cover", width: "100%", height: "100%" }} className="lazy" />
                                            </div>
                                        )
                                    })}
                                </Container>
                            ) : ""}
                            <p className='d-inline '>{t("setting.account.backgroundImage")}</p><br />
                            <Container style={{ textAlign: "center" }}>
                                <Image src={backgroundImage} style={{ width: "240px", height: "120px", marginRight: "30px" }} />
                                <MuiButton variant='outlined' onClick={(e) => document.getElementById("bg-file").click()}>{t("setting.account.selectImage")}</MuiButton><br /><br />
                                <Form.Control type="file" accept=".jpg,.jpeg,.gif,.png,.webp" className='d-none' id="bg-file" onChange={(e) => {
                                    setShowCropper(true)
                                    setCropTarget("outside")
                                    ImageUtil.loadImageBig(e.currentTarget.files, setSrcImage, false)
                                    document.getElementById("bg-file").value = ""
                                }} />
                            </Container>

                            <p className='d-inline '>{t("setting.account.profileImage")}</p><br />
                            <Container style={{ textAlign: "center" }}>
                                <Image src={profileImage} style={{ width: "200px", height: "200px", borderRadius: "10px", marginRight: "30px" }} />
                                <MuiButton variant='outlined' onClick={(e) => document.getElementById("file").click()}>{t("setting.account.selectImage")}</MuiButton><br /><br />
                                <Form.Control type="file" accept=".jpg,.jpeg,.gif,.png,.webp" className='d-none' id="file" onChange={(e) => {
                                    setShowCropper(true)
                                    setCropTarget("inside")
                                    ImageUtil.loadImageBig(e.currentTarget.files, setSrcImage, false)
                                    document.getElementById("file").value = ""
                                }} />
                            </Container>
                            <Image src={srcImage} id="load-image" style={{ display: "none" }} />
                            <pre style={{ backgroundColor: "#555555", color: "#FFFFFF", padding: "10px", borderRadius: "5px", display: messageShow }}>{message}</pre>
                            <Form style={{ margin: "0 auto", position: "relative", width: "100%", marginTop: "20px" }}>
                                <FloatingLabel controlId="characterName" label={<><span className='required'>必須</span> キャラクター名</>} className="mb-3 w-100">
                                    <Form.Control type="text" placeholder="" required autoComplete="new-password" value={characterName}
                                        onChange={(e) => setCharacterName(e.currentTarget.value)}
                                    />
                                </FloatingLabel>
                                <FloatingLabel controlId="characterNameKana" label={<>キャラクター名(ふりがな)</>} className="mb-3 w-100">
                                    <Form.Control type="text" placeholder="" required autoComplete="new-password" value={characterNameKana}
                                        onChange={(e) => setCharacterNameKana(e.currentTarget.value)}
                                    />
                                </FloatingLabel>
                                <div className='mb-3'>
                                    <p className='d-inline '><span className='required'>必須</span> キャラクターの性別 </p>
                                    <ButtonGroup>
                                        {sexRadio.map((radio, idx) => (
                                            <ToggleButton
                                                className='p-1'
                                                key={idx}
                                                id={`sex-${idx}`}
                                                type="radio"
                                                variant={'outline-primary'}
                                                name="sex-radio"
                                                value={radio.value}
                                                checked={characterSex === radio.value}
                                                onChange={(e) => {
                                                    setCharacterSex(e.currentTarget.value)
                                                }}
                                            >
                                                {radio.name}
                                            </ToggleButton>
                                        ))}
                                    </ButtonGroup>
                                </div>
                                <div style={{ border: "1px solid #BBBBBB", borderRadius: "5px" }} className='p-2 d-block mt-1 mb-3'>
                                    キャラクターの誕生日を設定&nbsp;
                                    <ButtonGroup>
                                        {yesOrNoRadio.map((radio, idx) => {
                                            return <ToggleButton
                                                className='p-1'
                                                key={idx}
                                                id={`character-birthday-${idx}`}
                                                type="radio"
                                                variant={'outline-primary'}
                                                name="character-birthday-radio"
                                                value={radio.value}
                                                checked={birthdaySet === radio.value}
                                                onChange={(e) => {
                                                    setBirthdaySet(e.currentTarget.value)
                                                }}
                                            >
                                                {radio.name}
                                            </ToggleButton>
                                        })}
                                    </ButtonGroup>&nbsp;
                                    {birthdaySet === "1" ? (
                                        <>
                                            <FormControl sx={{ m: 1, minWidth: 120 }}>
                                                <InputLabel id="month-label">月</InputLabel>
                                                <Select
                                                    labelId="month-label"
                                                    id="month"
                                                    label="Month"
                                                    value={month}
                                                    onChange={(e) => { setMonth(e.target.value) }}
                                                >
                                                    <MenuItem value="">
                                                        <em>None</em>
                                                    </MenuItem>
                                                    {[months.map(d => {
                                                        return <MenuItem value={d}>{d}</MenuItem>
                                                    })]}
                                                </Select>
                                            </FormControl>
                                            <FormControl sx={{ m: 1, minWidth: 120 }}>
                                                <InputLabel id="day-label">日</InputLabel>
                                                <Select
                                                    labelId="day-label"
                                                    id="day"
                                                    label="Day"
                                                    value={day}
                                                    onChange={(e) => { setDay(e.target.value) }}
                                                >
                                                    <MenuItem value="">
                                                        <em>None</em>
                                                    </MenuItem>
                                                    {[days.map(d => {
                                                        return <MenuItem value={d}>{d}</MenuItem>
                                                    })]}
                                                </Select>
                                            </FormControl>
                                        </>
                                    ) : ""}
                                </div>
                                <FloatingLabel controlId="characterAge" label={<>キャラクターの年齢</>} className="mb-3 w-50">
                                    <Form.Control type="text" placeholder="" required autoComplete="new-password" value={characterAge}
                                        onChange={(e) => setCharacterAge(e.currentTarget.value)}
                                    />
                                </FloatingLabel>
                                <Container className='mb-3'>
                                    <p className='d-inline '>{t("upload.image.styleOfPainting")} </p>
                                    <ButtonGroup>
                                        {styles.map((radio, idx) => (
                                            <ToggleButton
                                                className='p-1'
                                                key={idx}
                                                id={`style-${idx}`}
                                                type="radio"
                                                variant={'outline-primary'}
                                                name="style-radio"
                                                value={radio.value}
                                                checked={styleOfPainting === radio.value}
                                                onChange={(e) => {
                                                    setStyleOfPainting(e.currentTarget.value)
                                                }}
                                            >
                                                {radio.name}
                                            </ToggleButton>
                                        ))}
                                    </ButtonGroup>
                                </Container>
                                <Container className='d-flex flex-row justify-content-between mb-3'>
                                    <p className='d-inline'>{t("upload.image.ageLimit")} </p>
                                    <ButtonGroup>
                                        {nenrei.map((radio, idx) => (
                                            <ToggleButton
                                                className='p-1'
                                                key={idx}
                                                id={`age-limit-${idx}`}
                                                type="radio"
                                                variant={'outline-primary'}
                                                name="radio"
                                                value={radio.value}
                                                checked={ageLimit === radio.value}
                                                onChange={(e) => {
                                                    if (e.currentTarget.value === "3" || e.currentTarget.value === "4" || e.currentTarget.value === "5") {
                                                        setSexualExpression("")
                                                    }
                                                    if (e.currentTarget.value === "1") {
                                                        setSexualExpression("")
                                                    }
                                                    if (e.currentTarget.value === "2") {
                                                        setSexualExpression("1")
                                                    }
                                                    setAgeLimit(e.currentTarget.value)
                                                }}
                                            >
                                                {radio.name}
                                            </ToggleButton>
                                        ))}
                                    </ButtonGroup>
                                </Container>
                                <div className='mb-3' style={{ display: ageLimit === "1" ? "flex" : "none" }}>
                                    <p className='d-inline m-2'>{t("upload.image.whatIsSexual")} </p>
                                    <ButtonGroup className='m-2'>
                                        {yesOrNoRadio.map((radio, idx) => (
                                            <ToggleButton
                                                className='p-1'
                                                key={idx}
                                                id={`sexual-expression-${idx}`}
                                                type="radio"
                                                variant={'outline-primary'}
                                                name="sexual-radio"
                                                value={radio.value}
                                                checked={sexualExpression === radio.value}
                                                onChange={(e) => {
                                                    if (e.currentTarget.value === "1") {
                                                        setAgeLimit("2")
                                                    }
                                                    setSexualExpression(e.currentTarget.value)
                                                }}
                                            >
                                                {radio.name}
                                            </ToggleButton>
                                        ))}
                                    </ButtonGroup>
                                    <Icon.QuestionCircle style={{ marginLeft: "5px", cursor: "pointer" }} onClick={() => dialog("PG12とは ",
                                        <p>
                                            ■性的表現(軽微なものを含む)
                                            性的なものを想起させる、接吻、抱擁・下着の露出など。
                                            性行為や類似する動作を連想させる表現や表情。
                                            胸や谷間、乳首、臀部、股間等の強調や際どい表現や構図。
                                            極端に面積の少ない衣類や水着を身に着けた人物の描画や、
                                            露出度の非常に高い人物の描写、透けた衣服を身に着けた人物の描写や全裸等。<br />
                                            ■その他刺激的な表現
                                            軽微な創傷や流血、薬物の登場、児童が真似をする可能性のあるもの
                                            流血表現または刺激的にはオプションのセンシティブフラグをつけてください。
                                        </p>)} />
                                </div>
                                <FloatingLabel controlId="description" label={"自己紹介"} className='mb-3 w-100'>
                                    <Form.Control
                                        as="textarea"
                                        style={{ height: '100px' }}
                                        required
                                        value={description}
                                        onChange={(e) => {
                                            setDescription(e.currentTarget.value)
                                        }}
                                    />
                                </FloatingLabel>
                                <FloatingLabel controlId="title" label={<>趣味</>} className="mb-3 w-100">
                                    <Form.Control type="text" placeholder="" required autoComplete="new-password" value={hobby}
                                        onChange={(e) => setHobby(e.currentTarget.value)}
                                    />
                                </FloatingLabel>
                                <FloatingLabel controlId="notes" label={"二次創作ガイドラインやプロンプト利用の際の注意事項"} className='mb-3 w-100'>
                                    <Form.Control
                                        as="textarea"
                                        style={{ height: '100px' }}
                                        required
                                        value={notes}
                                        onChange={(e) => {
                                            setNotes(e.currentTarget.value)
                                        }}
                                    />
                                </FloatingLabel>
                                システムプロンプトはキャラクターとチャットするときのルールを指定します。他の利用者には公開されません。
                                <FloatingLabel controlId="notes" label={"システムプロンプト"} className='mb-3 w-100'>
                                    <Form.Control
                                        as="textarea"
                                        style={{ height: '100px' }}
                                        required
                                        value={system}
                                        onChange={(e) => {
                                            setSystem(e.currentTarget.value)
                                        }}
                                    />
                                </FloatingLabel>
                                <div className='mb-3'>
                                    <p className='d-inline '><span className='required'>必須</span> ファンアートを許可 </p>
                                    <ButtonGroup>
                                        {yesOrNoRadio.reverse().map((radio, idx) => (
                                            <ToggleButton
                                                className='p-1'
                                                key={idx}
                                                id={`fanart-${idx}`}
                                                type="radio"
                                                variant={'outline-primary'}
                                                name="fanart-radio"
                                                value={radio.value}
                                                checked={fanart === radio.value}
                                                onChange={(e) => {
                                                    setFanart(e.currentTarget.value)
                                                }}
                                            >
                                                {radio.name}
                                            </ToggleButton>
                                        ))}
                                    </ButtonGroup>
                                </div>
                                <InputGroup className='mb-3'>
                                    <InputGroup.Text>{fanart === "1" ? <><span className='required'>必須</span>&nbsp;</> : ""}#</InputGroup.Text>
                                    <Form.Control type="text" placeholder="ファンアート専用ハッシュタグ" required autoComplete="new-password"
                                        id='fanart-hash-tag'
                                        value={fanartHashTag}
                                        onChange={(e) => setFanartHashTag(e.currentTarget.value)}
                                    />
                                </InputGroup>
                                <InputGroup className='mb-3'>
                                    <InputGroup.Text>@</InputGroup.Text>
                                    <Form.Control type="text" placeholder="X ID" required autoComplete="new-password"
                                        id='x-id'
                                        value={xId}
                                        onChange={(e) => setXId(e.currentTarget.value)}
                                    />
                                </InputGroup>
                                <InputGroup className='mb-3'>
                                    <InputGroup.Text>@</InputGroup.Text>
                                    <Form.Control type="text" placeholder="YouTube ID" required autoComplete="new-password"
                                        id='yotuube-id'
                                        value={youtubeId}
                                        onChange={(e) => setYouTubeId(e.currentTarget.value)}
                                    />
                                </InputGroup>
                                <InputGroup className='mb-3'>
                                    <InputGroup.Text>@</InputGroup.Text>
                                    <Form.Control type="text" placeholder="Instagram ID" required autoComplete="new-password"
                                        id='instagram-id'
                                        value={instagramId}
                                        onChange={(e) => setInstagramId(e.currentTarget.value)}
                                    />
                                </InputGroup>
                                <InputGroup className='mb-3'>
                                    <InputGroup.Text>@</InputGroup.Text>
                                    <Form.Control type="text" placeholder="TikTok ID" required autoComplete="new-password"
                                        id='tiktok-id'
                                        value={tiktokId}
                                        onChange={(e) => setTiktokId(e.currentTarget.value)}
                                    />
                                </InputGroup>
                                <InputGroup className='mb-3'>
                                    <InputGroup.Text>sns.ourt-ai.work/@</InputGroup.Text>
                                    <Form.Control type="text" placeholder="Misskey ID(ourt AI)" required autoComplete="new-password"
                                        id='misskey-id'
                                        value={misskeyId}
                                        onChange={(e) => setMisskeyId(e.currentTarget.value)}
                                    />
                                </InputGroup>
                                <InputGroup className='mb-3'>
                                    <InputGroup.Text>@</InputGroup.Text>
                                    <Form.Control type="text" placeholder="Discord User Name" required autoComplete="new-password"
                                        id='discord-user-name'
                                        value={discordUserName}
                                        onChange={(e) => setDiscordUserName(e.currentTarget.value)}
                                    />
                                </InputGroup>
                                <InputGroup className='mb-3'>
                                    <InputGroup.Text>@</InputGroup.Text>
                                    <Form.Control type="text" placeholder="GitHub ID" required autoComplete="new-password"
                                        id='github-id'
                                        value={githubId}
                                        onChange={(e) => setGitHubId(e.currentTarget.value)}
                                    />
                                </InputGroup>
                                <InputGroup className='mb-3'>
                                    <InputGroup.Text>@</InputGroup.Text>
                                    <Form.Control type="text" placeholder="Hugging Face ID" required autoComplete="new-password"
                                        id='huggingface-id'
                                        value={huggingfaceId}
                                        onChange={(e) => setHuggingFaceId(e.currentTarget.value)}
                                    />
                                </InputGroup>
                                <InputGroup className='mb-3'>
                                    <InputGroup.Text><Icon.House /></InputGroup.Text>
                                    <Form.Control type="text" placeholder="ホームページ" required autoComplete="new-password"
                                        id='homepage'
                                        value={homepage}
                                        onChange={(e) => setHomepage(e.currentTarget.value)}
                                    />
                                </InputGroup>
                                <div className='d-none'>
                                    <InputGroup className="mb-3">
                                        <InputGroup.Checkbox style={{ cursor: "pointer" }} id="original" defaultChecked={imageInfo.info.original} />
                                        <Form.Control type="text" value={t("upload.image.original")} readOnly />
                                    </InputGroup>
                                    <InputGroup className="mb-3" style={{ maxWidth: "360px" }}>
                                        <InputGroup.Checkbox style={{ cursor: "pointer" }} id="limited-publication" defaultChecked={imageInfo.info.limited_publication} />
                                        <Form.Control type="text" value={t("upload.image.limitedPublication")} readOnly />
                                    </InputGroup>
                                    <InputGroup className="mb-3" style={{ maxWidth: "360px" }}>
                                        <InputGroup.Checkbox style={{ cursor: "pointer" }} id="display-new-list" defaultChecked={imageInfo.info.display_new_list} />
                                        <Form.Control type="text" value={t("upload.image.newPostHidden")} readOnly />
                                    </InputGroup>
                                    <InputGroup className="mb-3" style={{ maxWidth: "360px" }}>
                                        <InputGroup.Checkbox style={{ cursor: "pointer" }} id="display-ranking" defaultChecked={imageInfo.info.display_ranking} />
                                        <Form.Control type="text" value={t("upload.image.rankingHidden")} readOnly />
                                    </InputGroup>
                                </div>
                                <div className='d-none'>
                                    <div style={{ border: "1px solid #BBBBBB", borderRadius: "5px" }} className='p-2 d-inline-block'>
                                        <div>公開設定</div>
                                        <MuiButton onClick={() => setLimitDiv("public")} className='m-1' variant={limitDiv === "public" ? 'contained' : "outlined"} disableElevation>全体公開</MuiButton>
                                        <MuiButton onClick={() => setLimitDiv("plans")} className='m-1' variant={limitDiv === "plans" ? 'contained' : "outlined"} disableElevation disabled={loginInfo.bank_registed === 0 || loginInfo.id_auth === 0 || loginInfo.sms_auth === 0}>プランを選択</MuiButton>
                                        <MuiButton onClick={() => setLimitDiv("any_plans")} className='m-1' variant={limitDiv === "any_plans" ? 'contained' : "outlined"} disableElevation disabled={loginInfo.bank_registed === 0 || loginInfo.id_auth === 0 || loginInfo.sms_auth === 0}>すべての有料プラン</MuiButton>
                                        <div style={{ height: 400, width: '100%', display: limitDiv === "plans" ? "block" : "none" }} className='mt-3'>
                                            <DataGrid
                                                rows={rows}
                                                columns={columns}
                                                checkboxSelection
                                                pageSizeOptions={[]}
                                                onRowSelectionModelChange={(selection) => {
                                                    setSelectionPlans(selection)
                                                }}
                                                rowSelectionModel={selectionPlans}

                                            />
                                        </div>
                                    </div>
                                    <br />
                                    <div style={{ border: "1px solid #BBBBBB", borderRadius: "5px" }} className='p-2 d-inline-block mt-1 mb-3'>
                                        この投稿を販売&nbsp;
                                        <ButtonGroup>
                                            {yesOrNoRadio.map((radio, idx) => (
                                                <ToggleButton
                                                    className='p-1'
                                                    key={idx}
                                                    id={`unit-sell-${idx}`}
                                                    type="radio"
                                                    variant={'outline-primary'}
                                                    name="unit-sell-radio"
                                                    value={radio.value}
                                                    checked={unitSell === radio.value}
                                                    onChange={(e) => {
                                                        setUnitSell(e.currentTarget.value)
                                                    }}
                                                    disabled={loginInfo.bank_registed === 0 || loginInfo.id_auth === 0 || loginInfo.sms_auth === 0}
                                                >
                                                    {radio.name}
                                                </ToggleButton>
                                            ))}
                                        </ButtonGroup>&nbsp;
                                        {unitSell === "1" ? (
                                            <TextField
                                                type='number'
                                                value={unitAmount}
                                                onChange={(e) => setUnitAmount(e.currentTarget.value)}
                                                label="販売価格"
                                                id="unit-amount"
                                                sx={{ m: 1, width: '25ch' }}
                                                disabled={unitSell === "2" || loginInfo.bank_registed === 0 || loginInfo.id_auth === 0 || loginInfo.sms_auth === 0}
                                            />
                                        ) : ""}
                                        <Tooltip title="投稿を単品で販売する場合の金額を設定します。プランに指定されていても購入していれば閲覧できます。" arrow>
                                            <Icon.InfoCircle />
                                        </Tooltip>
                                    </div>
                                </div>
                                <span style={{ display: false === "1" ? "block" : "none" }}>使用モデル</span>
                                <Form.Select id="ai-model" className="mb-3" style={{ display: false === "1" ? "block" : "none" }}>
                                    <option value="no-select">更新なし</option>
                                    <option value="NovelAI">NovelAI</option>
                                    <option value="Holara">Holara</option>
                                    <option value="AnythingV3">Anything V3</option>
                                    <option value="AbyssOrangeMix">AbyssOrangeMix</option>
                                    <option value="ACertainThing">ACertainThing</option>
                                    <option value="ACertainModel">ACertainModel</option>
                                    <option value="ACertainty">ACertainty</option>
                                    <option value="Baka-DiffusionV1">Baka-DiffusionV1</option>
                                    <option value="Elysium_V1">Elysium_V1</option>
                                    <option value="Elysium_Anime_V1">Elysium_Anime_V1</option>
                                    <option value="Elysium_Anime_V2">Elysium_Anime_V2</option>
                                    <option value="Elysium_Anime_V3">Elysium_Anime_V3</option>
                                    <option value="Elysium_Kuro_Anime_V1">Elysium_Kuro_Anime_V1</option>
                                    <option value="Shirayuki_General_V1">Shirayuki_General_V1</option>
                                    <option value="Shirayuki_Anime_V1">Shirayuki_Anime_V1</option>
                                    <option value="WaifuDiffusion">Waifu Diffusion</option>
                                    <option value="StableDiffusion">Stable Diffusion</option>
                                    <option value="Midjouney">Midjouney</option>
                                    <option value="Nijijourney">niji・journey</option>
                                    <option value="TrinArt">TrinArt</option>
                                    <option value="Dalle-2">Dalle-2</option>
                                    <option value="Ernie-vilg">Ernie-vilg</option>
                                    <option value="UnstableDiffusion">Unstable Diffusion</option>
                                    <option value="HentaiDiffusion">HentaiDiffusion</option>
                                    <option value="MeituAIPainting">Meitu AI Painting</option>
                                    <option value="Rivera">Rivera</option>
                                    <option value="original">オリジナルモデル</option>
                                </Form.Select>
                                <Container className='d-flex justify-content-between' style={{ width: "200px" }}>
                                    {detailNo > 0 ? (
                                        <MuiButton variant='contained' onClick={() => {
                                            setDetailNo(detailNo - 1)
                                        }}>{t("common.prev")}</MuiButton>
                                    ) : <MuiButton variant='contained' disabled>{t("common.prev")}</MuiButton>}
                                    {imageInfoStatus && imageInfo.detail.length - 1 > detailNo ? (
                                        <MuiButton variant='contained' onClick={() => {
                                            setDetailNo(detailNo + 1)
                                        }}>{t("common.next")}</MuiButton>
                                    ) : <MuiButton variant='contained' disabled>{t("common.next")}</MuiButton>}
                                </Container>
                                <FloatingLabel controlId="prompt" label="生成テキスト、プロンプト(任意)" className='mb-3 w-100'>
                                    <Form.Control
                                        as="textarea"
                                        style={{ height: '100px' }}
                                        required
                                        value={promptList[detailNo]}
                                        onChange={(e) => {
                                            setPromptList(
                                                promptList.map((d, i) => {
                                                    if (i === detailNo) return e.currentTarget.value
                                                    return d
                                                }
                                                ))
                                        }}
                                    />
                                </FloatingLabel>
                                <FloatingLabel controlId="negative-prompt" label="ネガティブプロンプト(任意)" className='mb-3 w-100'>
                                    <Form.Control
                                        as="textarea"
                                        style={{ height: '100px' }}
                                        required
                                        value={negativePromptList[detailNo]}
                                        onChange={(e) => {
                                            setNegativePromptList(
                                                negativePromptList.map((d, i) => {
                                                    if (i === detailNo) return e.currentTarget.value
                                                    return d
                                                }
                                                ))
                                        }}
                                    />
                                </FloatingLabel>
                                {loginInfo.role && loginInfo.role.find(d => d.role_div === "admin" || d.role_div === "moderator") && imageInfo.info.user_id !== loginInfo.userId ? (
                                    <Container style={{ color: "red", fontWeight: "bold", fontSize: "24px", border: "3px solid red" }} className="mb-3">
                                        管理者権限で編集中です。
                                    </Container>
                                ) : ""}
                                <div className='mt-3'>
                                    <Button onClick={(e) => {
                                        /*if(description.value.trim().length === 0){
                                            dialog("エラー","概要を入力して下さい。")
                                            return false
                                        }*/
                                        if (ageLimit === "") {
                                            dialog(t("common.error"), "年齢制限を指定して下さい。")
                                            return false
                                        }
                                        // 全年齢の場合、性的表現について必須
                                        if (ageLimit === "1" || ageLimit === "2") {
                                            if ((sexualExpression === "" || sexualExpression === "0") && ageLimit === "1") {
                                                dialog(t("common.error"), "PG12の対象かを指定して下さい。")
                                                return false
                                            }
                                        } else if (ageLimit === "3" || ageLimit === "4" || ageLimit === "5") {
                                            if ((sexualExpression !== "" && sexualExpression !== "0")) {
                                                dialog(t("common.error"), "年齢制限がR指定の場合、PG12の選択は不要です。")
                                                return false
                                            }
                                        }
                                        promptList.forEach(d => {
                                            if (d.trim().length > 10000) {
                                                dialog(t("common.error"), "生成テキスト、プロンプトの上限は10,000文字です。")
                                                return false
                                            }
                                        })
                                        negativePromptList.forEach(d => {
                                            if (d.trim().length > 10000) {
                                                dialog(t("common.error"), "ネガティブプロンプトの上限は10,000文字です。")
                                                return false
                                            }
                                        })
                                        let original = document.getElementById("original").checked ? "1" : "0"
                                        let limitedPublication = document.getElementById("limited-publication").checked ? "1" : "0"
                                        let displayNewList = document.getElementById("display-new-list").checked ? "1" : "0"
                                        let displayRanking = document.getElementById("display-ranking").checked ? "1" : "0"
                                        edit(groupId, backgroundImage, profileImage, characterName.trim(), characterNameKana.trim(), characterSex, month + "-" + day, characterAge, hobby, notes, fanart, fanartHashTag.trim(),
                                            xId.trim(), youtubeId.trim(), instagramId.trim(), tiktokId.trim(), misskeyId.trim(), discordUserName.trim(), githubId.trim(), huggingfaceId.trim(),
                                            homepage.trim(), description.trim(), original, limitedPublication, displayNewList, displayRanking, promptList.map(d => d.trim()), negativePromptList.map(d => d.trim()))
                                    }}>{saving ? (<Spinner animation="border" size="sm" />) : ""} {imageInfoStatus && imageInfo.info.problem_status === 1 ? "審査依頼" : t("common.update")}</Button>
                                    <Button variant='danger' style={{ marginLeft: "10px" }} onClick={() => {
                                        dialog(t("common.confirm"),
                                            <Container className='text-center' style={{ margin: "0 auto" }}>
                                                <Container>{t("common.delete")}</Container>
                                                <Button
                                                    onClick={() => {
                                                        deleteImage(groupId).then(r => {
                                                            if (r.result) {
                                                                dialog(t("common.confirm"), t("common.deleted"))
                                                            } else {
                                                                dialog(t("common.error"), r.errors)
                                                            }
                                                        })
                                                    }}
                                                >{t("common.deleteStr")}</Button>
                                            </Container>
                                        )
                                    }}>{t("common.deleteStr")}</Button>
                                </div>
                            </Form>
                        </Tab>
                        <Tab eventKey="gacha" title={"生成ガチャ設定"} style={{ position: "relative", flex: "1" }}>
                            {/* MUIで再構成 */}
                            <Box component="form" sx={{ mt: 2, mx: "auto", maxWidth: 600 }}>
                                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                                    <Typography sx={{ mr: 2 }}>収益化を有効にする(準備中)</Typography>
                                    <MuiButton component="span" sx={{ p: 0, minWidth: 0 }}>
                                        <FormControl>
                                            <Switch
                                                disabled
                                                checked={gachaEnabled}
                                                onChange={(e) => setGachaEnabled(e.target.checked)}
                                                inputProps={{ 'aria-label': '収益化を有効にする' }}
                                                color="primary"
                                            />
                                        </FormControl>
                                    </MuiButton>
                                </Box>
                                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                                    <Typography sx={{ mr: 2 }}>生成結果のプロンプトを公開する</Typography>
                                    <MuiButton component="span" sx={{ p: 0, minWidth: 0 }}>
                                        <FormControl>
                                            <Switch
                                                checked={gachaPublicPromptEnabled}
                                                onChange={(e) => setGachaPublicPromptEnabled(e.target.checked)}
                                                inputProps={{ 'aria-label': '収益化を有効にする' }}
                                                color="primary"
                                            />
                                        </FormControl>
                                    </MuiButton>
                                </Box>
                                <Typography variant="h6" sx={{ mb: 2 }}>生成用プロンプト</Typography>
                                <Typography variant="h10" sx={{ mb: 2, color: "gray" }}>PG-12までのプロンプトを設定することができます。</Typography>
                                {gachaPrompts.map((gachaPrompt, index) => (
                                    <Box key={index} sx={{ mb: 3, border: "1px solid #eee", borderRadius: 2, p: 2, position: "relative" }}>
                                        <TextField
                                            label={`プロンプト ${index + 1}`}
                                            minRows={2}
                                            fullWidth
                                            variant="outlined"
                                            value={gachaPrompt.prompt}
                                            onChange={(e) => updateGachaPrompt(index, "prompt", e.target.value)}
                                            sx={{ mb: 2 }}
                                        />
                                        <TextField
                                            label={`ネガティブプロンプト ${index + 1}`}
                                            minRows={2}
                                            fullWidth
                                            variant="outlined"
                                            value={gachaPrompt.negativePrompt}
                                            onChange={(e) => updateGachaPrompt(index, "negativePrompt", e.target.value)}
                                            sx={{ mb: 2 }}
                                        />
                                        <IconButton
                                            aria-label="削除"
                                            color="error"
                                            onClick={() => removeGachaPrompt(index)}
                                            sx={{ position: "absolute", top: 8, right: 8 }}
                                        >
                                            <Icon.Trash />
                                        </IconButton>
                                    </Box>
                                ))}
                                <MuiButton
                                    variant="contained"
                                    color="primary"
                                    onClick={addGachaPrompt}
                                    sx={{ m: 1 }}
                                >
                                    プロンプトを追加
                                </MuiButton>
                                <MuiButton
                                sx={{ m: 1 }}
                                variant="contained"
                                color="primary"
                                onClick={(e) => {
                                    /*if(description.value.trim().length === 0){
                                        dialog("エラー","概要を入力して下さい。")
                                        return false
                                    }*/
                                    if (ageLimit === "") {
                                        dialog(t("common.error"), "年齢制限を指定して下さい。")
                                        return false
                                    }
                                    // 全年齢の場合、性的表現について必須
                                    if (ageLimit === "1" || ageLimit === "2") {
                                        if ((sexualExpression === "" || sexualExpression === "0") && ageLimit === "1") {
                                            dialog(t("common.error"), "PG12の対象かを指定して下さい。")
                                            return false
                                        }
                                    } else if (ageLimit === "3" || ageLimit === "4" || ageLimit === "5") {
                                        if ((sexualExpression !== "" && sexualExpression !== "0")) {
                                            dialog(t("common.error"), "年齢制限がR指定の場合、PG12の選択は不要です。")
                                            return false
                                        }
                                    }
                                    promptList.forEach(d => {
                                        if (d.trim().length > 10000) {
                                            dialog(t("common.error"), "生成テキスト、プロンプトの上限は10,000文字です。")
                                            return false
                                        }
                                    })
                                    negativePromptList.forEach(d => {
                                        if (d.trim().length > 10000) {
                                            dialog(t("common.error"), "ネガティブプロンプトの上限は10,000文字です。")
                                            return false
                                        }
                                    })
                                    let original = document.getElementById("original").checked ? "1" : "0"
                                    let limitedPublication = document.getElementById("limited-publication").checked ? "1" : "0"
                                    let displayNewList = document.getElementById("display-new-list").checked ? "1" : "0"
                                    let displayRanking = document.getElementById("display-ranking").checked ? "1" : "0"
                                    edit(groupId, backgroundImage, profileImage, characterName.trim(), characterNameKana.trim(), characterSex, month + "-" + day, characterAge, hobby, notes, fanart, fanartHashTag.trim(),
                                        xId.trim(), youtubeId.trim(), instagramId.trim(), tiktokId.trim(), misskeyId.trim(), discordUserName.trim(), githubId.trim(), huggingfaceId.trim(),
                                        homepage.trim(), description.trim(), original, limitedPublication, displayNewList, displayRanking, promptList.map(d => d.trim()), negativePromptList.map(d => d.trim()))
                                }}>{saving ? (<Spinner animation="border" size="sm" />) : ""} {imageInfoStatus && imageInfo.info.problem_status === 1 ? "審査依頼" : t("common.update")}</MuiButton>
                            </Box>
                        </Tab>
                    </Tabs>
                </Container>
            </div>
        </div>
    )
}

export default CharacterEditPopup;
